module.exports = __webpack_public_path__ + "img/body-model-arm-right.e77d7bb8.svg";